import isWeb from './isWeb';

let isJDApp = true;

if (isWeb) {
    const ua = (navigator && navigator.userAgent) || '';
    isJDApp = /jdapp/.test(ua);
}

export default isJDApp;
